import { MODE } from 'constants/mode';

export function handleFocus () {
  if (EventTarget.prototype._addEventListener) {
    return;
  } else {
    EventTarget.prototype._addEventListener = EventTarget.prototype.addEventListener;

    EventTarget.prototype.addEventListener = function (a, b, c) {
      if (a && a.indexOf('focus') > -1) { // ignore the focus event handler
        return;
      }
      if (typeof c === 'undefined') c = false;
      this._addEventListener(a, b, c);
      if (!this.eventListenerList) this.eventListenerList = {};
      if (!this.eventListenerList[a]) this.eventListenerList[a] = [];
      this.eventListenerList[a].push({listener: b, options: c});
    };

    EventTarget.prototype._getEventListeners = function (a) {
      if (!this.eventListenerList) this.eventListenerList = {};
      if (typeof a === 'undefined') { return this.eventListenerList; }
      return this.eventListenerList[a];
    };
  }
}

export function wrapFocusIn (mode) {
  // do not let bootstrap modal to hold focus in definition mode
  let $ = window.$;
  if ($ && $._data) {
    let events = $._data(document, 'events') || {};
    (events['focusin'] || []).forEach((item) => {
      if (!item._ar && item.namespace !== '') {
        let modalFocusInFn = item.handler;
        item.handler = (e) => {
          if (mode === MODE.EDIT) {
            return;
          }
          modalFocusInFn(e);
        };
        item._ar = 'true';
      }
    });
  } else {
    handleFocus();
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/shared/utils/focusHandler.js
 **/